import React from 'react';
import {Body, Button} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './GigLoadError.module.scss';

interface Props {
  onRetry: () => void;
}

export default function GigLoadError({onRetry}: Props) {
  return (
    <div className={styles.container} data-testid="gig-load-error">
      <Body size="md">
        {translate('Couldn’t load this gig. Please try again.')}
      </Body>
      <Button
        testID="gig-load-error-retry"
        appearance="brand"
        mode="filled"
        size="medium"
        onClick={onRetry}
      >
        {translate('Try again')}
      </Button>
    </div>
  );
}
